import React, { useCallback, useState, useEffect } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import MainForm from "./form"
import Result from "./result"
import { useGetConfigMutation } from "../../api/services"
import "./assets/style.scss"

const getQueryStringValue = (paramName, defaultValue) => {
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams){
    let retVal:any = queryParams.get(paramName)
    if (retVal){
      return retVal
    }
    return defaultValue
  }
}

const Landing = () => {
  const [items, setItems] = useState([])
  const [reportYear, setReportYear] = useState(() => getQueryStringValue("y", ""))
  const [description, setDescription] = useState('')

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("YTMList.Landing.Description")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setDescription(payload.configValue.replace("{reportYear}", reportYear))
        }
      })
  }, [getConfig])

  const handleItemsFetched = (items) => {
    setItems(items)
  }

  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={12} lg={16} xl={16} className="landing-initialinfo-col">
            <Block className="landing-ytm-description">
              <Block dangerouslySetInnerHTML={{ __html: description }} />
            </Block>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={16} xl={16} className="landing-initialinfo-col">
            <MainForm onItemsFetched={handleItemsFetched} reportYear={reportYear}/>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={16} xl={16} className="landing-initialinfo-col">
            <Result items={items}/>
          </Col>
        </Row>
      </Grid>
    </Block>
  )
}

export default Landing
